import type { LocalConflictBadgeProps } from "./types-local-conflict-badge";
import { LocalConflictBadgeView } from "./view-local-conflict-badge";

/** Selo "⚠ N Conflito(s)" na coluna do Local: só indicador; o card vem da faixa no Gantt. */
export function LocalConflictBadge(props: LocalConflictBadgeProps) {
  return <LocalConflictBadgeView {...props} />;
}

export type * from "./types-local-conflict-badge";
